<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
<p-fieldset>


    <ng-template pTemplate="header">Periodos</ng-template>
    <!--p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="Regresar" icon="pi pi-chevron-left" class="p-button-warning p-mr-2" ></button>
            <<button pButton pRipple label="Validar" icon="pi pi-chevron-plus" class="p-button-success p-mr-2" ></button>
            button pButton pRipple [label]="Delete" icon="pi pi-trash" class="p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedProducts || !selectedProducts.length"></button>
        </ng-template>
    
        <<ng-template pTemplate="right">
            <p-fileUpload mode="basic" accept="image/*" [maxFileSize]="1000000" label="Import" chooseLabel="Import" class="p-mr-2 p-d-inline-block"></p-fileUpload>
            <button pButton pRipple label="Export" icon="pi pi-upload" class="p-button-help"></button>
        </ng-template>>
    </p-toolbar-->
    <div class="card">

        <div class="p-grid">
            <div class="p-col-12 p-md-6">
                <div class="card">
                    <div class="p-fluid">
                        <div class="p-field p-grid">
                            <label for="firstname4" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Período Actual</label>
                            <div class="p-col-12 p-md-10">
                                <!--input id="firstname4" type="text" pInputText-->
                                <span class="p-text-bold">{{ currentPeriod }}</span>
                            </div>
                        </div>
                        <div class="p-field p-grid">
                            <label for="coordinput" class="p-col-8 p-mb-2 p-md-2 p-mb-md-0">Id Localidad Padre</label>
                            <div class="p-col-8 p-md-6">
                                <p-inputNumber id="coordinput" [(ngModel)]="findCoordInput" [min]="0" mode="decimal"></p-inputNumber>
                            </div>
                            <p-button label="Buscar" icon="pi pi-search" class="p-mr-2 p-mb-2" (click)="findCoord()"></p-button>
                        </div>
                        

                        
                    </div>
                </div>
            </div>
        </div>

        <p-table #dt [value]="lstStore" [rows]="20" [paginator]="true" [globalFilterFields]="['descri','type','storeId','storeId']"
                [(selection)]="selectedCoord" [rowHover]="true" dataKey="storeId" styleClass="p-datatable-responsive-demo"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [showCurrentPageReport]="true" editMode="row" responsiveLayout="scroll">
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        <h5 class="p-m-0">Coordinaciones   {{ storeInfo.descri }} </h5>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Buscar..." />
                        </span>
                    </div>
                    
                    <span class="p-input-icon-left">
                        <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()" class="p-button-success p-mr-2"  pTooltip="XLS" tooltipPosition="bottom"></button>
                        <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()" class="p-button-warning p-mr-2" pTooltip="PDF" tooltipPosition="bottom"></button>
                    </span>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <!--th pSortableColumn="storeId">id Zona <p-sortIcon field="storeId"></p-sortIcon></th-->
                        <th pSortableColumn="storeId">ID Hijo <p-sortIcon field="storeId"></p-sortIcon></th>
                        <th pSortableColumn="descri">Nombre <p-sortIcon field="descri"></p-sortIcon></th>
                        <th pSortableColumn="type">Tipo<p-sortIcon field="type"></p-sortIcon></th>
                        <th pSortableColumn="unidadMed">Seleccionar<p-sortIcon field="treastName"></p-sortIcon></th>
                        <th ></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-coord>
                    <tr>
                        <td>{{coord.storeId | number}}</td>
                        <td>{{coord.descri}}</td>
                        <td>{{coord.type}}</td>
                        <td>
                            <button type="button"  pButton pRipple icon="pi pi-cog" (click)="redirectDetail(coord)"></button>
                        </td>
                    </tr>
                </ng-template>

                    <ng-template pTemplate="summary">
                        <div class="p-d-flex p-ai-center p-jc-between">
                            En total hay {{lstStore ? lstStore.length : 0 }} coordinaciones.
                        </div>
                    </ng-template>
        </p-table>

        
    </div>

</p-fieldset>
























<!--
<p-table #dt [value]="lstPeriodStore"
    [globalFilterFields]="['incidentId','personName','subject','body','email','zonCoord','natioCoord','userId','assignedTo']"
    [rowHover]="true" dataKey="id" styleClass="p-datatable-responsive-demo"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
[showCurrentPageReport]="true">
<ng-template pTemplate="caption">
    <div class="p-d-flex p-ai-center p-jc-between">
        <h5 class="p-m-0">Incidencias</h5>
        <span class="p-input-icon-left">
            <i class="pi pi-search"></i>
            <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Search..." />
        </span>
    </div> 

    <span class="p-input-icon-left">
        <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()" class="p-button-success p-mr-2"  pTooltip="XLS" tooltipPosition="bottom"></button>
        <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()" class="p-button-warning p-mr-2" pTooltip="PDF" tooltipPosition="bottom"></button>
    </span>
</ng-template>

<ng-template pTemplate="header">
    <tr>   
        <th pSortableColumn="id.year">Año<p-sortIcon field="id.year">
            </p-sortIcon>
        </th>
        <th pSortableColumn="id.period">Periodo<p-sortIcon field="id.period">
            </p-sortIcon>
        </th>
        <th pSortableColumn="strDate">Fecha Inicio<p-sortIcon field="strDate">
            </p-sortIcon>
        </th>
        <th pSortableColumn="zonCoord">Zona<p-sortIcon field="zonCoord">
            </p-sortIcon>
        </th>    
        <th style="width:4rem">Eliminar</th>
    </tr>
</ng-template>
<ng-template pTemplate="body" let-value>
    <tr>
        <td>{{value.incidentId}}</td>
        <td>{{value.personName}}</td>
        <td>{{value.subject}}</td>
        <td>{{value.zonCoord}}</td>
        <td>{{value.natioCoord}}</td>
        <td>{{value.assignedTo}}</td>
        <td>{{value.status}} {{value.cancelSts}}</td>
        <td>
            <button type="button"  pButton pRipple icon="pi pi-search" (click)="selectIncident(value.incidentId)"></button>
        </td>
    </tr>
</ng-template>
<ng-template pTemplate="summary">
    <div class="p-d-flex p-ai-center p-jc-between">
        Total {{lstEmails ? lstEmails.length : 0 }} Options.
    </div>
</ng-template>
</p-table>

-->